import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Función para mostrar notificación de actualización
const showUpdateNotification = (onUpdateComplete?: () => void) => {
  // Crear un elemento de notificación
  const notification = document.createElement('div');
  notification.innerHTML = `
    <div style="
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 16px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 10000;
      max-width: 300px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    ">
      <div style="font-weight: 600; margin-bottom: 8px;">
        🚀 ¡Nueva versión disponible!
      </div>
      <div style="font-size: 14px; margin-bottom: 12px; opacity: 0.9;">
        Hay una actualización lista para instalar
      </div>
      <div style="display: flex; gap: 8px;">
        <button onclick="
          window.location.reload();
          if (window.onUpdateComplete) window.onUpdateComplete();
        " style="
          background: white;
          color: #4CAF50;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
        ">
          Actualizar
        </button>
        <button onclick="this.parentElement.parentElement.parentElement.remove()" style="
          background: transparent;
          color: white;
          border: 1px solid rgba(255,255,255,0.3);
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
        ">
          Más tarde
        </button>
      </div>
    </div>
  `;
  
  // Asignar callback global
  (window as any).onUpdateComplete = onUpdateComplete;
  
  document.body.appendChild(notification);
  
  // Auto-remove después de 10 segundos si no se actúa
  setTimeout(() => {
    if (notification.parentElement) {
      notification.remove();
    }
  }, 10000);
};

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registrado: ', registration);
        
        // Escuchar actualizaciones del SW - DESHABILITADO: Ahora se maneja en AppUpdateContext
        /*
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            console.log('SW: Nueva versión detectada');
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('SW: Nueva versión instalada');
                // Mostrar notificación al usuario de que hay una actualización
                showUpdateNotification(() => {
                  // Después de aplicar la actualización, verificar si se puede mostrar Face ID
                  console.log('Actualización aplicada, verificando Face ID...');
                });
              }
            });
          }
        });
        */
      })
      .catch((registrationError) => {
        console.log('SW falló: ', registrationError);
      });
  });

  // Escuchar mensajes del Service Worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      console.log('SW: Actualización aplicada:', event.data.version);
      // Opcional: mostrar notificación al usuario de que se actualizó
    }
  });
}
